module.exports = __webpack_public_path__ + "img/tz.aa46b770.svg";